var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{staticClass:"mt-n5 mt-md-n7 mt-lg-n8"},[_c('TeamSection',{attrs:{"title":"Nossos Consultores"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }